/* eslint-disable max-len */
import React from 'react';

export const MonitorErrorImage = () => {
  return (
    <svg
      width="432px"
      height="154px"
      viewBox="0 0 447 200"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Error Monitor</title>
      <desc>Created with Sketch.</desc>
      <g id="Error-Monitor" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(34.000000, 41.000000)">
          <g id="Group-9-Copy-4" transform="translate(0.000000, 13.000000)" fill="#39AACF">
            <path
              d="M313.316358,29.6939 L165.683642,29.6939 C164.202175,29.6939 163,28.5751441 163,27.1943713 C163,25.8135984 164.202175,24.6939 165.683642,24.6939 L313.316358,24.6939 C314.798837,24.6939 316,25.8135984 316,27.1943713 C316,28.5751441 314.798837,29.6939 313.316358,29.6939"
              id="Fill-1"
              opacity="0.161760603"
            ></path>
            <path
              d="M375.934769,29.2659 L326.737269,29.2659 C325.245139,29.2659 324.036157,28.0789 324.036157,26.6139 C324.036157,25.1489 325.245139,23.9609 326.737269,23.9609 L375.934769,23.9609 C377.426898,23.9609 378.63588,25.1489 378.63588,26.6139 C378.63588,28.0789 377.426898,29.2659 375.934769,29.2659"
              id="Fill-3"
              opacity="0.16"
            ></path>
            <path
              d="M338.356112,41.6939 L299.643888,41.6939 C298.183369,41.6939 297,40.5751441 297,39.1943713 C297,37.8135984 298.183369,36.6939 299.643888,36.6939 L338.356112,36.6939 C339.816631,36.6939 341,37.8135984 341,39.1943713 C341,40.5751441 339.816631,41.6939 338.356112,41.6939"
              id="Fill-6"
              opacity="0.161760603"
            ></path>
            <path
              d="M357.243721,41.6939 L350.757319,41.6939 C349.234713,41.6939 348,40.5751441 348,39.1943713 C348,37.8135984 349.234713,36.6939 350.757319,36.6939 L357.243721,36.6939 C358.766326,36.6939 360,37.8135984 360,39.1943713 C360,40.5751441 358.766326,41.6939 357.243721,41.6939"
              id="Fill-8"
              opacity="0.161760603"
            ></path>
            <path
              d="M332.243959,5.6939 L325.75708,5.6939 C324.234606,5.6939 323,4.57514411 323,3.19437125 C323,1.8135984 324.234606,0.6939 325.75708,0.6939 L332.243959,0.6939 C333.766433,0.6939 335,1.8135984 335,3.19437125 C335,4.57514411 333.766433,5.6939 332.243959,5.6939"
              id="Fill-10"
              opacity="0.161760603"
            ></path>
            <path
              d="M45.2437208,79.6939 L38.7562792,79.6939 C37.233674,79.6939 36,78.5749332 36,77.1939 C36,75.8128668 37.233674,74.6939 38.7562792,74.6939 L45.2437208,74.6939 C46.766326,74.6939 48,75.8128668 48,77.1939 C48,78.5749332 46.766326,79.6939 45.2437208,79.6939"
              id="Fill-12"
              opacity="0.161760603"
            ></path>
            <path
              d="M291.243721,79.6939 L284.756279,79.6939 C283.233674,79.6939 282,78.5749332 282,77.1939 C282,75.8128668 283.233674,74.6939 284.756279,74.6939 L291.243721,74.6939 C292.766326,74.6939 294,75.8128668 294,77.1939 C294,78.5749332 292.766326,79.6939 291.243721,79.6939"
              id="Fill-14"
              opacity="0.161760603"
            ></path>
            <path
              d="M316.24476,67.6939 L309.757319,67.6939 C308.234713,67.6939 307,66.5749332 307,65.1939 C307,63.8138095 308.234713,62.6939 309.757319,62.6939 L316.24476,62.6939 C317.766326,62.6939 319,63.8138095 319,65.1939 C319,66.5749332 317.766326,67.6939 316.24476,67.6939"
              id="Fill-16"
              opacity="0.161760603"
            ></path>
            <path
              d="M236.324941,16.6939 L112.675059,16.6939 C111.197321,16.6939 110,15.5751441 110,14.1943713 C110,12.8135984 111.197321,11.6939 112.675059,11.6939 L236.324941,11.6939 C237.80167,11.6939 239,12.8135984 239,14.1943713 C239,15.5751441 237.80167,16.6939 236.324941,16.6939"
              id="Fill-18"
              opacity="0.161760603"
            ></path>
            <path
              d="M298.338542,16.6939 L247.661458,16.6939 C246.192237,16.6939 245,15.5751441 245,14.1943713 C245,12.8135984 246.192237,11.6939 247.661458,11.6939 L298.338542,11.6939 C299.808767,11.6939 301,12.8135984 301,14.1943713 C301,15.5751441 299.808767,16.6939 298.338542,16.6939"
              id="Fill-20"
              opacity="0.161760603"
            ></path>
            <path
              d="M217.339463,67.6939 L131.66154,67.6939 C130.191824,67.6939 129,66.5749332 129,65.1939 C129,63.8138095 130.191824,62.6939 131.66154,62.6939 L217.339463,62.6939 C218.809179,62.6939 220,63.8138095 220,65.1939 C220,66.5749332 218.809179,67.6939 217.339463,67.6939"
              id="Fill-22"
              opacity="0.161760603"
            ></path>
            <path
              d="M229.32259,41.6939 L130.678419,41.6939 C129.199383,41.6939 128,40.5751441 128,39.1943713 C128,37.8135984 129.199383,36.6939 130.678419,36.6939 L229.32259,36.6939 C230.801627,36.6939 232,37.8135984 232,39.1943713 C232,40.5751441 230.801627,41.6939 229.32259,41.6939"
              id="Fill-24"
              opacity="0.161760603"
            ></path>
            <path
              d="M246.234619,41.6939 L239.765381,41.6939 C238.237748,41.6939 237,40.5751441 237,39.1943713 C237,37.8135984 238.237748,36.6939 239.765381,36.6939 L246.234619,36.6939 C247.762252,36.6939 249,37.8135984 249,39.1943713 C249,40.5751441 247.762252,41.6939 246.234619,41.6939"
              id="Fill-26"
              opacity="0.161760603"
            ></path>
            <path
              d="M223.23486,29.6939 L216.76514,29.6939 C215.238683,29.6939 214,28.5751441 214,27.1943713 C214,25.8135984 215.238683,24.6939 216.76514,24.6939 L223.23486,24.6939 C224.761317,24.6939 226,25.8135984 226,27.1943713 C226,28.5751441 224.761317,29.6939 223.23486,29.6939"
              id="Fill-28"
              opacity="0.161760603"
            ></path>
            <path
              d="M311.312843,41.6939 L256.68817,41.6939 C255.203749,41.6939 254,40.5751441 254,39.1943713 C254,37.8135984 255.203749,36.6939 256.68817,36.6939 L311.312843,36.6939 C312.796251,36.6939 314,37.8135984 314,39.1943713 C314,40.5751441 312.796251,41.6939 311.312843,41.6939"
              id="Fill-30"
              opacity="0.161760603"
            ></path>
            <path
              d="M151.320102,28.6939 L56.6798977,28.6939 C55.1994867,28.6939 54,27.5751441 54,26.1943713 C54,24.8135984 55.1994867,23.6939 56.6798977,23.6939 L151.320102,23.6939 C152.800513,23.6939 154,24.8135984 154,26.1943713 C154,27.5751441 152.800513,28.6939 151.320102,28.6939"
              id="Fill-32"
              opacity="0.161760603"
            ></path>
            <path
              d="M31.3391566,28.6939 L2.66084339,28.6939 C1.19095818,28.6939 0,27.5751441 0,26.1943713 C0,24.8135984 1.19095818,23.6939 2.66084339,23.6939 L31.3391566,23.6939 C32.8090418,23.6939 34,24.8135984 34,26.1943713 C34,27.5751441 32.8090418,28.6939 31.3391566,28.6939"
              id="Fill-34"
              opacity="0.161760603"
            ></path>
            <path
              d="M76.2346194,16.6939 L69.7643379,16.6939 C68.2377477,16.6939 67,15.5751441 67,14.1943713 C67,12.8135984 68.2377477,11.6939 69.7643379,11.6939 L76.2346194,11.6939 C77.7622523,11.6939 79,12.8135984 79,14.1943713 C79,15.5751441 77.7622523,16.6939 76.2346194,16.6939"
              id="Fill-36"
              opacity="0.161760603"
            ></path>
            <path
              d="M128.321385,16.6939 L86.6786152,16.6939 C85.1989126,16.6939 84,15.5751441 84,14.1943713 C84,12.8135984 85.1989126,11.6939 86.6786152,11.6939 L128.321385,11.6939 C129.801087,11.6939 131,12.8135984 131,14.1943713 C131,15.5751441 129.801087,16.6939 128.321385,16.6939"
              id="Fill-38"
              opacity="0.161760603"
            ></path>
            <path
              d="M119.321385,41.6939 L77.6786152,41.6939 C76.1989126,41.6939 75,40.5751441 75,39.1943713 C75,37.8135984 76.1989126,36.6939 77.6786152,36.6939 L119.321385,36.6939 C120.801087,36.6939 122,37.8135984 122,39.1943713 C122,40.5751441 120.801087,41.6939 119.321385,41.6939"
              id="Fill-40"
              opacity="0.161760603"
            ></path>
            <path
              d="M79.3213848,41.6939 L37.6786152,41.6939 C36.1989126,41.6939 35,40.5751441 35,39.1943713 C35,37.8135984 36.1989126,36.6939 37.6786152,36.6939 L79.3213848,36.6939 C80.8000774,36.6939 82,37.8135984 82,39.1943713 C82,40.5751441 80.8000774,41.6939 79.3213848,41.6939"
              id="Fill-42"
              opacity="0.161760603"
            ></path>
            <path
              d="M323.32351,16.6939 L308.67649,16.6939 C307.197961,16.6939 306,15.5751441 306,14.1943713 C306,12.8135984 307.197961,11.6939 308.67649,11.6939 L323.32351,11.6939 C324.802039,11.6939 326,12.8135984 326,14.1943713 C326,15.5751441 324.802039,16.6939 323.32351,16.6939"
              id="Fill-44"
              opacity="0.161760603"
            ></path>
            <path
              d="M132.290059,79.6939 L95.7099411,79.6939 C94.2129337,79.6939 93,78.5749332 93,77.1939 C93,75.8128668 94.2129337,74.6939 95.7099411,74.6939 L132.290059,74.6939 C133.787066,74.6939 135,75.8128668 135,77.1939 C135,78.5749332 133.787066,79.6939 132.290059,79.6939"
              id="Fill-46"
              opacity="0.161760603"
            ></path>
            <path
              d="M250.905488,5.305 L211.700557,5.305 C210.240365,5.305 209.05726,4.118 209.05726,2.653 C209.05726,1.188 210.240365,1.42108547e-13 211.700557,1.42108547e-13 L250.905488,1.42108547e-13 C252.36568,1.42108547e-13 253.548785,1.188 253.548785,2.653 C253.548785,4.118 252.36568,5.305 250.905488,5.305"
              id="Fill-48"
              opacity="0.16"
            ></path>
            <path
              d="M118.30535,67.6939 L65.6946498,67.6939 C64.2060895,67.6939 63,66.5749332 63,65.1939 C63,63.8138095 64.2060895,62.6939 65.6946498,62.6939 L118.30535,62.6939 C119.793911,62.6939 121,63.8138095 121,65.1939 C121,66.5749332 119.793911,67.6939 118.30535,67.6939"
              id="Fill-51"
              opacity="0.161760603"
            ></path>
            <path
              d="M285.335193,53.6939 L223.664807,53.6939 C222.193737,53.6939 221,52.5751441 221,51.1943713 C221,49.8135984 222.193737,48.6939 223.664807,48.6939 L285.335193,48.6939 C286.807268,48.6939 288,49.8135984 288,51.1943713 C288,52.5751441 286.807268,53.6939 285.335193,53.6939"
              id="Fill-53"
              opacity="0.161760603"
            ></path>
            <path
              d="M326.335193,67.6939 L264.664807,67.6939 C263.193737,67.6939 262,66.5749332 262,65.1939 C262,63.8138095 263.193737,62.6939 264.664807,62.6939 L326.335193,62.6939 C327.807268,62.6939 329,63.8138095 329,65.1939 C329,66.5749332 327.807268,67.6939 326.335193,67.6939"
              id="Fill-55"
              opacity="0.161760603"
            ></path>
            <path
              d="M211.309186,53.6939 L103.690814,53.6939 C102.204373,53.6939 101,52.5751441 101,51.1943713 C101,49.8135984 102.204373,48.6939 103.690814,48.6939 L211.309186,48.6939 C212.795627,48.6939 214,49.8135984 214,51.1943713 C214,52.5751441 212.795627,53.6939 211.309186,53.6939"
              id="Fill-57"
              opacity="0.161760603"
            ></path>
            <path
              d="M71.2965902,53.6939 L16.7034098,53.6939 C15.2100104,53.6939 14,52.5751441 14,51.1943713 C14,49.8135984 15.2100104,48.6939 16.7034098,48.6939 L71.2965902,48.6939 C72.7899896,48.6939 74,49.8135984 74,51.1943713 C74,52.5751441 72.7899896,53.6939 71.2965902,53.6939"
              id="Fill-59"
              opacity="0.161760603"
            ></path>
            <path
              d="M92.3791013,53.6939 L82.6208987,53.6939 C81.1730795,53.6939 80,52.5751441 80,51.1943713 C80,49.8135984 81.1730795,48.6939 82.6208987,48.6939 L92.3791013,48.6939 C93.8269205,48.6939 95,49.8135984 95,51.1943713 C95,52.5751441 93.8269205,53.6939 92.3791013,53.6939"
              id="Fill-61"
              opacity="0.161760603"
            ></path>
            <path
              d="M305.379101,53.6939 L295.620899,53.6939 C294.173079,53.6939 293,52.5751441 293,51.1943713 C293,49.8135984 294.173079,48.6939 295.620899,48.6939 L305.379101,48.6939 C306.826921,48.6939 308,49.8135984 308,51.1943713 C308,52.5751441 306.826921,53.6939 305.379101,53.6939"
              id="Fill-63"
              opacity="0.161760603"
            ></path>
            <path
              d="M107.234619,28.6939 L100.765381,28.6939 C99.2377477,28.6939 98,27.5751441 98,26.1943713 C98,24.8135984 99.2377477,23.6939 100.765381,23.6939 L107.234619,23.6939 C108.762252,23.6939 110,24.8135984 110,26.1943713 C110,27.5751441 108.762252,28.6939 107.234619,28.6939"
              id="Fill-65"
              opacity="0.161760603"
            ></path>
            <path
              d="M240.5706,5.305 L234.3656,5.305 C232.9016,5.305 231.7136,4.118 231.7136,2.653 C231.7136,1.188 232.9016,1.42108547e-13 234.3656,1.42108547e-13 L240.5706,1.42108547e-13 C242.0356,1.42108547e-13 243.2226,1.188 243.2226,2.653 C243.2226,4.118 242.0356,5.305 240.5706,5.305"
              id="Fill-67"
              opacity="0.16"
            ></path>
            <path
              d="M109.234619,67.6939 L102.765381,67.6939 C101.237748,67.6939 100,66.5749332 100,65.1939 C100,63.8138095 101.237748,62.6939 102.765381,62.6939 L109.234619,62.6939 C110.762252,62.6939 112,63.8138095 112,65.1939 C112,66.5749332 110.762252,67.6939 109.234619,67.6939"
              id="Fill-70"
              opacity="0.161760603"
            ></path>
            <path
              d="M281.375,29.6939 L279.625,29.6939 C278.174915,29.6939 277,28.5751441 277,27.1943713 C277,25.8135984 278.174915,24.6939 279.625,24.6939 L281.375,24.6939 C282.825085,24.6939 284,25.8135984 284,27.1943713 C284,28.5751441 282.825085,29.6939 281.375,29.6939"
              id="Fill-72"
              opacity="0.161760603"
            ></path>
            <path
              d="M104.7439,5.305 L83.9079,5.305 C82.4429,5.305 81.2549,4.118 81.2549,2.653 C81.2549,1.188 82.4429,1.42108547e-13 83.9079,1.42108547e-13 L104.7439,1.42108547e-13 C106.2089,1.42108547e-13 107.3959,1.188 107.3959,2.653 C107.3959,4.118 106.2089,5.305 104.7439,5.305"
              id="Fill-74"
              opacity="0.16"
            ></path>
          </g>
          <g id="Group-8" transform="translate(114.000000, 0.000000)">
            <g id="Group-6-Copy">
              <rect
                id="Rectangle-Copy-2"
                stroke="#C4C4C5"
                strokeWidth="2"
                fill="#FFFFFF"
                x="0"
                y="0"
                width="152"
                height="101"
                rx="2"
              ></rect>
              <line x1="17" y1="17.322" x2="28.964" y2="24.697" id="Stroke-10-Copy" stroke="#C3C3C3"></line>
              <line x1="31.9034" y1="26.5085" x2="34.2354" y2="27.9455" id="Stroke-11-Copy" stroke="#C3C3C3"></line>
              <line x1="21.4297" y1="23.7361" x2="29.9877" y2="29.0121" id="Stroke-12-Copy" stroke="#C3C3C3"></line>
              <rect id="Rectangle" stroke="#C4C4C5" x="7" y="8" width="138" height="81.7777778"></rect>
              <rect id="Rectangle" stroke="#C4C4C5" strokeWidth="2" x="70" y="101" width="11" height="10"></rect>
              <polygon id="Rectangle" stroke="#C4C4C5" strokeWidth="2" points="42 111 110 111 114 119 38 119"></polygon>
              <line x1="120" y1="93.8074" x2="139.734" y2="93.8074" id="Stroke-8-Copy" stroke="#C3C3C3"></line>
              <line x1="142.8789" y1="93.8074" x2="145.4499" y2="93.8074" id="Stroke-9-Copy" stroke="#C3C3C3"></line>
            </g>
            <g id="Group-10" transform="translate(44.000000, 22.000000)">
              <path
                d="M30.4800543,0.523456379 L0.527967624,52.4291309 C0.125221939,53.1270727 0.628903887,54 1.43539463,54 L61.3385686,54 C62.1440599,54 62.6477419,53.1270727 62.2439968,52.4291309 L32.2919102,0.523456379 C31.8901639,-0.17448546 30.8828,-0.17448546 30.4800543,0.523456379"
                id="Fill-1"
                fill="#FEFEFE"
              ></path>
              <path
                d="M30.4800543,0.523456379 L0.527967624,52.4291309 C0.125221939,53.1270727 0.628903887,54 1.43539463,54 L61.3385686,54 C62.1440599,54 62.6477419,53.1270727 62.2439968,52.4291309 L32.2919102,0.523456379 C31.8901639,-0.17448546 30.8828,-0.17448546 30.4800543,0.523456379 Z"
                id="Stroke-3"
                stroke="#C4C4C5"
                strokeWidth="2"
              ></path>
              <polygon
                id="Stroke-7"
                stroke="#C3C3C3"
                points="29.3862712 36 33.3862712 36 33.3862712 18 29.3862712 18"
              ></polygon>
              <polygon
                id="Fill-8"
                fill="#FEFEFE"
                points="28.3862712 45 32.3862712 45 32.3862712 41 28.3862712 41"
              ></polygon>
              <polygon
                id="Stroke-9"
                stroke="#C3C3C3"
                points="29.3862712 45 33.3862712 45 33.3862712 41 29.3862712 41"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default MonitorErrorImage;
